module.exports = __webpack_public_path__ + "img/mowerwalk_parked.75d6594c.svg";